/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import * as io from 'io-ts';

/**
 * The SCV customer entity type.
 */
export type EntityScvCustomer = io.TypeOf<typeof ScvCustomer>;

/**
 * The SCV customer entity definition.
 */
export const ScvCustomer = io.intersection(
  [
    io.partial({
      $verifiedEmail: io.string,
      countryCode: io.string,
      email: io.string,
      firstName: io.string,
      lastName: io.string,
      profileImageURL: io.string,
      region: io.string,
    }),
    io.type({
      $createdDatetime: io.string,
      $customerid: io.string,
      $segments: io.record(io.string, io.string),
      $updatedDatetime: io.string,
    }),
    // There are additional properties which may be available.
    // However, this is unpredictable and can be different across tenants.
    io.record(io.string, io.unknown),
  ],
  `ScvCustomer`,
);
